import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const StoreAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHaveStoreAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            store: {
              isHaveAddAccess: true,
              isHaveEditAccess: true,
              isHaveDeleteAccess: true,
              isHaveExportAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            store: {
              isHaveAddAccess: false,
              isHaveEditAccess: false,
              isHaveDeleteAccess: false,
              isHaveExportAccess: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHaveStoreAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      store: { ...j.store, [name]: checked },
    }));
  };

  return (
    <Collapse in={featuresAccess.isHaveStoreAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.store && featuresAccess.store.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveEditAccess")}
          checked={
            (featuresAccess.store && featuresAccess.store.isHaveEditAccess) ||
            false
          }
          name={"isHaveEditAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.store && featuresAccess.store.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.store && featuresAccess.store.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default StoreAccess;
